export enum InitialFlow {
  MEETING_FLOW = 'MeetingFlow',
  DIRECT_FLOW = 'DirectFlow',
}
